<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { CAMPAIGN_STATUS, getCampaignStatusOptions } from "../../../../utils/statusEngine.js";
  import { loadAnakatechClients } from "../anakatech/utils/anakatechCatalogs.js";
  import Dropdown from "../../../ui/Dropdown.svelte";

  export let filters = {
    client: "",
    clientId: "",
    clientName: "",
    campaignName: "",
    type: "",
    statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
  };
  export let syncing = false;

  const dispatch = createEventDispatcher();
  const SPORT_TYPE_OPTIONS = [
    { value: "FREE_BET", label: "Free Bet" },
    { value: "CASHBACK", label: "Cashback" },
    { value: "RISK_FREE_BET", label: "Risk Free Bet" },
  ];
  const STATUS_OPTIONS = getCampaignStatusOptions();
  let clients = [];

  async function loadClients() {
    try {
      const catalog = await loadAnakatechClients();
      clients = catalog.clients;
    } catch (error) {
      console.error("Error cargando clientes de Altenar:", error);
    }
  }

  function clearFilters() {
    filters = {
      client: "",
      clientId: "",
      clientName: "",
      campaignName: "",
      type: "",
      statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
    };
  }

  function handleClientChange(event) {
    const clientCode = event.detail || "";
    const selected = clients.find(
      (client) => String(client?.code) === String(clientCode),
    );
    filters = {
      ...filters,
      client: clientCode,
      clientId: selected?.id ?? "",
      clientName:
        selected?.namesite ?? selected?.name ?? selected?.clientName ?? "",
    };
  }

  function handleStatusChange(event) {
    filters = {
      ...filters,
      statuses: Array.isArray(event.detail)
        ? event.detail.map(Number).filter(Number.isFinite)
        : [],
    };
  }

  onMount(loadClients);
</script>

<section class="filter-panel" aria-label="Filtros de campañas Altenar">
  <div class="filter-grid">
    <div class="field">
      <span class="field-label">Cliente</span>
      <Dropdown
        options={clients}
        bind:value={filters.client}
        placeholder="Todos"
        valueKey="code"
        labelKey="namesite"
        isStructuredDescription={true}
        paramStructuredName={["code", "namesite"]}
        on:change={handleClientChange}
      />
    </div>

    <div class="field">
      <label for="altenar-campaign-filter">Campaña</label>
      <input
        id="altenar-campaign-filter"
        class="form-control"
        placeholder="Ej. Black Friday"
        bind:value={filters.campaignName}
      />
    </div>

    <div class="field">
      <span class="field-label">Tipo</span>
      <Dropdown
        options={SPORT_TYPE_OPTIONS}
        bind:value={filters.type}
        placeholder="Todos"
        valueKey="value"
        labelKey="label"
      />
    </div>

    <div class="field">
      <span class="field-label">Estado</span>
      <Dropdown
        options={STATUS_OPTIONS}
        value={filters.statuses}
        placeholder="Todos"
        valueKey="value"
        labelKey="label"
        multiple={true}
        on:change={handleStatusChange}
      />
    </div>
  </div>

  <div class="toolbar">
    <button type="button" class="toolbar-button clear-button" on:click={clearFilters}>
      Limpiar
    </button>
    <button
      type="button"
      class="toolbar-button sync-button"
      disabled={syncing}
      on:click={() => dispatch("sync")}
    >
      {syncing ? "Sincronizando…" : "Sincronizar"}
    </button>
  </div>
</section>

<style>
  .filter-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem;
    align-items: end;
    margin: 0 10px 0.5rem;
    padding: 0.75rem;
    border: 1px solid var(--bs-border-color, #e5e7eb);
    border-radius: 0.5rem;
    background: #fff;
  }
  .filter-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(140px, 1fr));
    gap: 0.6rem;
    align-items: end;
  }
  .field { display: flex; min-width: 0; flex-direction: column; }
  .field label,
  .field-label {
    display: block;
    margin-bottom: 0.3rem;
    color: #666;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .field input {
    min-height: 38px;
    padding: 0.4rem 0.55rem;
    border: 1px solid var(--bs-border-color, #e2e6ea);
    border-radius: 0.4rem;
    background: #fff;
    color: #333;
    font-size: 0.875rem;
  }
  .field input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  }
  .toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
  }
  .toolbar-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    min-width: max-content;
    padding: 0 1rem;
    border: 1px solid #cfc8cd;
    border-radius: 0.4rem;
    background: #fff;
    color: #2a1a28;
    font-size: 0.85rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
  }
  .toolbar-button:hover:not(:disabled) {
    border-color: #8f818a;
    background: #f7f2f5;
  }
  .toolbar-button:disabled { cursor: wait; opacity: 0.6; }
  .toolbar-button:focus-visible {
    border-color: #ff0090;
    outline: 0;
    box-shadow: 0 0 0 3px rgba(255, 0, 144, 0.15);
  }
  @media (max-width: 1200px) {
    .filter-panel { grid-template-columns: 1fr; }
    .filter-grid { grid-template-columns: repeat(2, minmax(140px, 1fr)); }
  }
  @media (max-width: 640px) {
    .filter-grid { grid-template-columns: minmax(0, 1fr); }
    .toolbar { width: 100%; flex-wrap: wrap; }
    .toolbar-button { flex: 1 1 auto; }
  }
</style>
